import {
  faSort,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ComponentProps, ReactNode } from "react";
import { TableHead } from "components/ui/table";

type SortDirection = "asc" | "desc";

type SortableTableHeadProps = Omit<ComponentProps<typeof TableHead>, "children"> & {
  active: boolean;
  ariaLabel: string;
  children: ReactNode;
  direction: SortDirection;
  onSort: () => void;
};

export function SortableTableHead({
  active,
  ariaLabel,
  children,
  direction,
  onSort,
  ...tableHeadProps
}: SortableTableHeadProps) {
  const sortIcon = active ? (direction === "asc" ? faSortUp : faSortDown) : faSort;

  return (
    <TableHead
      aria-sort={active ? (direction === "asc" ? "ascending" : "descending") : "none"}
      {...tableHeadProps}
    >
      <button
        aria-label={ariaLabel}
        className="inline-flex items-center gap-1 text-left font-inherit hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        onClick={onSort}
        type="button"
      >
        <span>{children}</span>
        <FontAwesomeIcon aria-hidden="true" className="text-xs" icon={sortIcon} />
      </button>
    </TableHead>
  );
}